module.exports = __webpack_public_path__ + "img/zhanhuigaikuang.ed8e395e.jpg";